import { TFunction } from 'i18next';

export enum GICVendors {
  TD = 'TD',
  RBC = 'RBC',
}
export const RBC_INFO_LINK_HREF = 'https://www.applyboard.com/services/RBC-student-gic-program';
export const TD_INFO_LINK_HREF = 'https://www.applyboard.com/services/td-student-gic-program';
export const TD_COMPONENT_STR = GICVendors.TD.valueOf();
export const RBC_COMPONENT_STR = GICVendors.RBC.valueOf();

export const allValidGicCountriesOptionList = (
  t: TFunction<'translation', undefined>,
): { label: string; value: string }[] => [
  {
    label: t('landingPage.countries.br'),
    value: 'BR',
  },
  {
    label: t('landingPage.countries.cn'),
    value: 'CN',
  },
  {
    label: t('landingPage.countries.co'),
    value: 'CO',
  },
  {
    label: t('landingPage.countries.cr'),
    value: 'CR',
  },
  {
    label: t('landingPage.countries.in'),
    value: 'IN',
  },
  {
    label: t('landingPage.countries.ma'),
    value: 'MA',
  },
  {
    label: t('landingPage.countries.pe'),
    value: 'PE',
  },
  {
    label: t('landingPage.countries.ph'),
    value: 'PH',
  },
  {
    label: t('landingPage.countries.pk'),
    value: 'PK',
  },
  {
    label: t('landingPage.countries.sn'),
    value: 'SN',
  },
  {
    label: t('landingPage.countries.vn'),
    value: 'VN',
  },
];

export const validRBCGicCountriesArray = ['BR', 'CO', 'CR', 'PE', 'IN', 'CN', 'PH', 'VN'];
export const validTDGicCountriesArray = ['CN', 'IN', 'MA', 'PK', 'PH', 'SN', 'VN'];
export const allValidGicCountriesArray = Array.from(
  new Set(validRBCGicCountriesArray.concat(validTDGicCountriesArray)),
);

export enum GicLandingPageEvents {
  PageView = 'GIC Landing Page - Page View',
  BankSelected = 'GIC Landing Page - Bank Selected',
}
